import React, { useState, useMemo, forwardRef, useCallback, useRef } from 'react';
import { Form } from 'antd'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import { isEmpty, uniqBy } from 'lodash';

const GithubSecretScanMappingForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [mappedRepoList] = useState(() => {
    // this state contains the already mapped application/site
    // This is stored because the project and version dropdowns are paginated
    // and if the option selected is not on 2st page, then the ID is displayed as this is how select works
    if (props.record) {
      const { repositoryName, owner } = props.record;
      const repoArr = repositoryName.split(',')
      return {
        repository: repoArr.map(repo=> ({ id: repo, name: repo, otherProperties: { owner: { login: owner}}}))
      }
    }
    return { repository: []  }
  })
  const repoRef = useRef({ repository: mappedRepoList.repository });

  const getExtraFieldsData = useCallback((config) => {
    const { repositoryName } = config;

    const data = repoRef.current.repository.reduce((acc,cv) =>{
      const { id, name,  otherProperties: { owner:{ login } } } = cv;
      if(repositoryName.includes(id)){
        acc.name.push(name);
        acc["owner"] = login;
      }
      return acc;
    },{name:[]})
    return ({
      repositoryName: data.name.join(),
      owner: data.owner
    });
  },[]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return { 
      repositoryName: config.repositoryName.split(','),
    };
  }, []);

  const projectChangeHandler = useCallback((value, field,selectValue) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    let updatedConfiguration = [
      ...configurations
    ];
    updatedConfiguration[name] = {
      ...updatedConfiguration[name],
    }
    form.setFieldsValue({ configurations: updatedConfiguration })
  }, [form])

  const fetchRepos = useCallback((params) => {
    const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);
    promise.then((response) => {
      const { projects } = response;
      // merging the already mapped application/site to the fetched list so that if the selected value is not in the option list
      // then id should not be displayed
      if(mappedRepoList['repository'].length > 0 && !isEmpty(response.projects)){
        response.projects = uniqBy([...response.projects, ...mappedRepoList['repository']], 'name');
      }

      repoRef.current['repository'] = uniqBy([...projects, ...repoRef.current['repository']],'name')
    });
    return { promise,cancel}
  }, [props.toolName, mappedRepoList]);

  const extraFields = useMemo(() => ([
    {
      name: 'repositoryName',
      colSpan: '16',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Repository',
      props: {
        api: fetchRepos,
        mode:"multiple",
        apiParams: {login_id: props.loginConfigId},
        onChange: projectChangeHandler,
        autoFocus: true
      },
      rules: [{ required: true, message: 'Repository is required' }]
    }
  ]), [projectChangeHandler, fetchRepos,props.loginConfigId]);


  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default GithubSecretScanMappingForm;